import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { aboutImages, features } from '../data/mockData';
import { CheckCircle2, FileText } from 'lucide-react';

const AboutSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Label */}
        <div className="text-center mb-4">
          <span className="text-[#166534] font-medium text-sm uppercase tracking-wider">About Us</span>
        </div>

        {/* Section Title */}
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 text-center mb-16 max-w-3xl mx-auto leading-tight">
          Innovative Healthcare
          <br />
          With AI-Driven Care
        </h2>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left - Images */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img
                  src={aboutImages.image1}
                  alt="Healthcare professional with patient"
                  className="w-full h-80 object-cover rounded-2xl shadow-lg"
                />
              </div>
              <div className="pt-8">
                <img
                  src={aboutImages.image2}
                  alt="Medical team consultation"
                  className="w-full h-72 object-cover rounded-2xl shadow-lg"
                />
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="space-y-8">
            {/* Features List */}
            <ul className="space-y-4">
              {features.map((feature, index) => (
                <li key={index} className="flex items-center gap-3">
                  <CheckCircle2 className="w-6 h-6 text-[#dc2626] flex-shrink-0" />
                  <span className="text-gray-800 font-medium text-lg">{feature}</span>
                </li>
              ))}
            </ul>

            <div className="flex flex-wrap items-end gap-6">
              <Link to="/team">
                <Button className="bg-[#166534] hover:bg-[#14532d] text-white px-8 py-5 text-base font-medium rounded-lg transition-all duration-300 hover:shadow-lg">
                  And More
                </Button>
              </Link>

              {/* Stats Card */}
              <div className="bg-[#fee2e2] rounded-2xl p-6 min-w-[200px]">
                <div className="flex justify-center mb-2">
                  <div className="w-12 h-12 bg-gray-900 rounded-full flex items-center justify-center">
                    <FileText className="w-6 h-6 text-white" />
                  </div>
                </div>
                <p className="text-5xl font-bold text-gray-900 text-center">10+</p>
                <p className="text-gray-600 text-center text-sm mt-1">
                  Years Of AI HealthCare
                  <br />
                  Experience
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
